
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.891 20.592h-3.68v-5.778c0-1.38-.028-3.152-1.916-3.152-1.916 0-2.209 1.501-2.209 3.05v5.88h-3.68V8.71h3.531v1.623h.05c.492-.934 1.694-1.92 3.487-1.92 3.728 0 4.417 2.462 4.417 5.663v6.517zM5.124 7.253a2.132 2.132 0 01-2.142-2.127C2.982 3.952 3.937 3 5.124 3c1.18 0 2.14.952 2.14 2.126a2.136 2.136 0 01-2.14 2.127zm-1.753 13.34H7.07V8.8H3.37v11.792z","fill":"#000","opacity":".2"}})])
          )
        }
      }
    